<template>
  <of-dialog
    :title="formTitle"
    @onCancel="cancel"
    @onConfirm="confirm"
    :isConfirm="isConfirm"
    :width="width"
  >
    <div slot="content">
      <el-form
        ref="form"
        :model="dataForm"
        label-width="120px"
        :rules="editFormRules"
      >
        <el-form-item
          label="基础信息"
          style="background-color: #f8f8f9"
          label-width="80px"
        >
        </el-form-item>
        <el-row>
          <el-col :span="8">
            <el-form-item label="姓名："
              >{{ dataForm.Name }}
            </el-form-item></el-col
          >
          <el-col :span="8">
            <el-form-item label="性别："
              >{{ showSex(dataForm.Sex) }}
            </el-form-item></el-col
          >
          <el-col :span="8">
            <el-form-item label="民族："
              >{{ dataForm.National }}
            </el-form-item></el-col
          >
        </el-row>
        <el-row>
          <el-col :span="8">
            <el-form-item label="国籍："
              >{{ dataForm.Nationality }}
            </el-form-item></el-col
          >
          <el-col :span="8">
            <el-form-item label="籍贯："
              >{{ dataForm.NationPlace }}
            </el-form-item></el-col
          >
          <el-col :span="8">
            <el-form-item label="职业："
              >{{ dataForm.Perfessional }}
            </el-form-item></el-col
          >
        </el-row>
        <el-row>
          <el-col :span="8">
            <el-form-item label="证件类型："
              >{{ dataForm.IdType }}
            </el-form-item></el-col
          >
          <el-col :span="8">
            <el-form-item label="证件号码："
              >{{ dataForm.IdentityCard }}
            </el-form-item></el-col
          >
          <el-col :span="8">
            <el-form-item label="学历："
              >{{ dataForm.Education }}
            </el-form-item></el-col
          >
        </el-row>
        <el-row>
          <el-col :span="8">
            <el-form-item label="手机号码："
              >{{ dataForm.Phone }}
            </el-form-item></el-col
          >
          <el-col :span="8">
            <el-form-item label="QQ号码："
              >{{ dataForm.QQNo }}
            </el-form-item></el-col
          >
          <el-col :span="8">
            <el-form-item label="微信号："
              >{{ dataForm.WeChatNo }}
            </el-form-item></el-col
          >
        </el-row>
        <el-row>
          <el-col :span="8">
            <el-form-item label="身高(CM)："
              >{{ dataForm.Height }}
            </el-form-item></el-col
          >
          <el-col :span="8">
            <el-form-item label="体重(KG)："
              >{{ dataForm.Weight }}
            </el-form-item></el-col
          >
          <el-col :span="8">
            <el-form-item label="血型："
              >{{ dataForm.BloodType }}
            </el-form-item></el-col
          >
        </el-row>
        <el-row>
          <el-col :span="24">
            <el-form-item label="电子邮箱："
              >{{ dataForm.Email }}
            </el-form-item></el-col
          >
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item label="无偿献血次数："
              >{{ dataForm.BloodDonation }}
            </el-form-item></el-col
          >
          <el-col :span="12">
            <el-form-item label="是否愿意参加志愿者服务：" label-width="200px"
              >{{ showIsVolunteer(dataForm.IsVolunteer) }}
            </el-form-item></el-col
          >
        </el-row>
        <el-row>
          <el-col :span="24">
            <el-form-item label="户籍所在地址："
              >{{ dataForm.DomicilePlace }}
            </el-form-item></el-col
          >
        </el-row>
        <el-row>
          <el-col :span="24">
            <el-form-item label="经常居住地："
              >{{ dataForm.Address }}
            </el-form-item></el-col
          >
        </el-row>
        <el-row>
          <el-col :span="24">
            <el-form-item label="工作单位/学校："
              >{{ dataForm.WorkUnit }}
            </el-form-item></el-col
          >
        </el-row>
        <el-row>
          <el-col :span="24">
            <el-form-item label="单位/学校地址："
              >{{ dataForm.School }}
            </el-form-item></el-col
          >
        </el-row>
        <el-row>
          <el-col :span="24">
            <el-form-item label="单位/学校电话："
              >{{ dataForm.ContactPhone }}
            </el-form-item></el-col
          >
        </el-row>
        <el-row>
          <el-col :span="24">
            <el-form-item label="备注："
              >{{ dataForm.Content }}
            </el-form-item></el-col
          >
        </el-row>
        <div v-for="(item, i) in dataForm.Relations" :key="i">
          <el-form-item
            label="亲友信息"
            style="background-color: #f8f8f9"
            label-width="80px"
          >
          </el-form-item>
          <el-row>
            <el-col :span="8">
              <el-form-item label="姓名："
                >{{ item.Name }}
              </el-form-item></el-col
            >
            <el-col :span="8">
              <el-form-item label="关系代码："
                >{{ item.RelationCode }}
              </el-form-item></el-col
            >
            <el-col :span="8">
              <el-form-item label="手机号："
                >{{ item.Phone }}
              </el-form-item></el-col
            >
          </el-row>
          <el-row>
            <el-col :span="8">
              <el-form-item label="固定电话："
                >{{ item.FixPhone }}
              </el-form-item></el-col
            >
            <el-col :span="16">
              <el-form-item label="微信号："
                >{{ item.WechatNo }}
              </el-form-item></el-col
            >
          </el-row>
          <el-row>
            <el-col :span="242">
              <el-form-item label="联系地址："
                >{{ item.Address }}
              </el-form-item></el-col
            >
          </el-row>
        </div>
        <el-form-item
          label="送样信息"
          style="background-color: #f8f8f9"
          label-width="80px"
        >
        </el-form-item>
        <el-row>
          <el-col :span="8">
            <el-form-item label="送样批次：" prop="SampleBatch"
              ><el-input
                placeholder="送样批次"
                v-model="dataForm.SampleBatch"
                clearable
                maxlength="10"
              ></el-input> </el-form-item
          ></el-col>
          <el-col :span="8">
            <el-form-item label="送样编号：" prop="SampleNo"
              ><el-input
                placeholder="送样编号"
                v-model="dataForm.SampleNo"
                clearable
                maxlength="10"
              ></el-input> </el-form-item
          ></el-col>
          <el-col :span="8">
            <el-form-item label="采样日期：" prop="SamplingTime"
              ><el-date-picker
                v-model="dataForm.SamplingTime"
                type="date"
                value-format="timestamp"
                placeholder="选择日期"
              ></el-date-picker> </el-form-item
          ></el-col>
        </el-row>
        <el-row>
          <el-col :span="8">
            <el-form-item label="送样日期：" prop="SendSampleTime"
              ><el-date-picker
                v-model="dataForm.SendSampleTime"
                type="date"
                value-format="timestamp"
                placeholder="选择日期"
              ></el-date-picker> </el-form-item
          ></el-col>
          <el-col :span="8">
            <el-form-item label="是否填报名表：" prop="IsApply"
              ><el-radio v-model="dataForm.IsApply" :label="true">是</el-radio>
              <el-radio v-model="dataForm.IsApply" :label="false">否</el-radio>
            </el-form-item></el-col
          >
          <el-col :span="8">
            <el-form-item label="血样管数量2支：" prop="IsBloodSample"
              ><el-radio v-model="dataForm.IsBloodSample" :label="true"
                >是</el-radio
              >
              <el-radio v-model="dataForm.IsBloodSample" :label="false"
                >否</el-radio
              >
            </el-form-item></el-col
          >
        </el-row>
        <el-row>
          <el-col :span="24">
            <el-form-item label="状态：" prop="MatchingStatue"
              ><el-select v-model="dataForm.MatchingStatue" placeholder="状态">
                <el-option
                  v-for="item in MatchingStatue"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                  clearable
                ></el-option>
              </el-select> </el-form-item
          ></el-col>
        </el-row>
      </el-form>
    </div>
  </of-dialog>
</template>

<script>
import OfDialog from "@/components/controls/of_dialog/of_dialog";
import { saveAs } from "file-saver";
import api from "@/modules/zjrc/api";

export default {
  name: "edit",
  props: {
    id: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      editFormRules: {
        SampleBatch: {
          required: true,
          message: "请输入送样批次",
          trigger: "blur",
        },
        SampleNo: {
          required: true,
          message: "请输入送样编号",
          trigger: "blur",
        },
        SamplingTime: {
          required: true,
          message: "请选择采样日期",
          trigger: "blur",
        },
        SendSampleTime: {
          required: true,
          message: "请选择送样日期",
          trigger: "blur",
        },
        MatchingStatue: {
          required: true,
          message: "请选择状态",
          trigger: "blur",
        },
      },
      formTitle: "造血干细胞捐献志愿者登记信息",
      isConfirm: false,
      width: "85%",
      dataForm: {
        IsBloodSampl:true,
        IsApply:true
      },
      MatchingStatue: [
        { value: 0, label: "采血样" },
        { value: 1, label: "入库" },
        { value: 2, label: "筛选" },
        { value: 3, label: "高分辨" },
        { value: 4, label: "体检" },
        { value: 5, label: "捐献成功" },
      ],
    };
  },
  components: {
    OfDialog,
  },
  computed: {
    showSex() {
      return (data) => {
        return data == 0 ? "女" : "男";
      };
    },
    showMatchingStatue() {
      return (data) => {
        switch (data) {
          case 0:
            return "采血样";
          case 1:
            return "入库";
          case 2:
            return "筛选";
          case 3:
            return "高分辨";
          case 4:
            return "体检";
          case 5:
            return "捐献成功";
        }
      };
    },
    showIsVolunteer() {
      return (data) => {
        return data == 0 ? "否" : "是";
      };
    },
  },
  mounted() {
    let that = this;
    //window.console.log(this.dataForm)
    that.loadData();
  },
  methods: {
    //初始化数据
    loadData() {
      let that = this;
      let params = { Id: that.id };
      api.QueryDonationStemCellById(params).then((res) => {
        if (res.data.Code == 0) {
          that.dataForm = res.data.Data;
          if (that.dataForm.SamplingTime) {
            that.dataForm.SamplingTime = that.dataForm.SamplingTime * 1000;
          }
          if(that.dataForm.SendSampleTime) {
            that.dataForm.SendSampleTime = that.dataForm.SendSampleTime * 1000;
          }
          that.dataForm.MatchingStatue===null?that.dataForm.MatchingStatue=0:that.dataForm.MatchingStatue;
          that.dataForm.IsBloodSampl===true
        }
      });
    },
    //取消
    cancel() {
      this.$emit("formCallBack", null);
    },
    //提交
    confirm() {
      let that = this;
      that.$refs.form.validate((valid) => {
        if (valid) {
          that.isConfirm = true;
          let params = Object.assign({}, that.dataForm);
          params.SamplingTime = params.SamplingTime / 1000;
          params.SendSampleTime = params.SendSampleTime / 1000;
          api
            .UpdateDonationStemCell(params)
            .then((res) => {
              if (res.data.Code === 0) {
                this.$message({
                  message: "提交成功",
                  type: "success",
                });
                this.$emit("formCallBack", params);
              } else {
                this.$message({
                  message: res.data.Message,
                  type: "error",
                });
              }
            })
            .catch((e) => {
              this.$message({
                message: e.toString(),
                type: "error",
              });
            });
          that.isConfirm = false;
        }
      });
    },
  },
};
</script>

<style  scoped>
.el-date-editor >>> .el-input__icon {
  display: none;
}
.el-form >>> .el-date-editor {
  width: 292.3px;
}
.el-form >>> .el-select {
  width: 292.3px;
}
.el-form >>> .el-form-item__label {
  font-weight: 500;
}
</style>
